import React from "react";
import AxiosClient, { clearAxiosAuthorizationHeader } from "../Network/AxiosClient";

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

const AppLogout = ({ children }) => {
  let timer;

  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      // clears any pending timer.
      resetTimer();

      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      // logs out user

      logoutAction();
    }, 3600000); //30min=1800000 //1000ms = 1secs. logoutAction is called after this time
  };

  // this resets the timer if it exists.
  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  // when component mounts, it adds an event listeners to the window
  // each time any of the event is triggered, the app automatically logs out.
  React.useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        //console.log(item);
        resetTimer();
        handleLogoutTimer();
      });
    });
  }, []);

  // logs out user by clearing out auth token in localStorage and redirecting url to /login page.
  const logoutAction = () => {
    if (!localStorage.getItem("currUserToken")) return;
    const token = localStorage.getItem("currUserToken");
    const user_id = localStorage.getItem("user_id");
    AxiosClient.post(`${process.env.REACT_APP_API_URL}/api/auth/logout`, {
      user_id: user_id,
    })
      .then((res) => {
        clearAxiosAuthorizationHeader();
        localStorage.clear();
        window.location.pathname = "/signin";
      })
      .catch((err) => {
        console.log(err);
        alert("Something went wrong when trying to log out!");
      });
  };

  return children;
};

export default AppLogout;
